import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import Nav from './components/Nav';
import Footer from './components/Footer';
import MainPage from './pages/MainPage';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Lazy load pages for code splitting
const PortfolioPage = lazy(() => import('./pages/PortfolioPage'));
const ImpressumPage = lazy(() => import('./pages/ImpressumPage'));
const DatenschutzPage = lazy(() => import('./pages/DatenschutzPage'));
const GuidePage = lazy(() => import('./pages/GuidePage'));
const MastermindPage = lazy(() => import('./pages/MastermindPage'));
const LeadMagnetPage = lazy(() => import('./pages/LeadMagnetPage'));
const AdminApp = lazy(() => import('./admin/AdminApp'));

// Loading fallback component
const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50vh',
    color: '#888'
  }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid rgba(255,255,255,0.1)',
        borderTopColor: '#764ba2',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '0 auto 1rem'
      }} />
      Loading...
    </div>
    <style>{`
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

const PublicPages = () => (
  <Routes>
    <Route path="/" element={<MainPage />} />
    <Route path="/portfolio" element={<PortfolioPage />} />
    <Route path="/impressum" element={<ImpressumPage />} />
    <Route path="/datenschutz" element={<DatenschutzPage />} />
    <Route path="/guide" element={<GuidePage />} />
    <Route path="/mastermind" element={<MastermindPage />} />
    <Route path="/lead/:slug" element={<LeadMagnetPage />} />
  </Routes>
);

const PublicShell = () => (
  <div className="app-fox">
    <Nav />
    <Suspense fallback={<PageLoader />}>
      <PublicPages />
    </Suspense>
    <Footer />
  </div>
);

const Shell = () => (
  <Routes>
    <Route
      path="/admin/*"
      element={(
        <Suspense fallback={<PageLoader />}>
          <AdminApp />
        </Suspense>
      )}
    />
    <Route path="/en/*" element={<PublicShell />} />
    <Route path="/*" element={<PublicShell />} />
  </Routes>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <LanguageProvider>
          <ScrollToTop />
          <Shell />
        </LanguageProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
